<template>
	<div class="bookmarks-page page pt-5" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<v-card-text v-else-if="isBlocked !== null">
			<v-skeleton-loader
				style="max-width: 555px"
				v-bind="attrs"
				type="card"
				v-if="isLoading"
			/>
			<div v-else>
				<BookmarkList :currentUser="currentUser" :bookmarks="bookmarksList" />
			</div>
		</v-card-text>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BookmarkList from '@/components/Profile/BookmarkList.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'ProfileBookmarksPage',
	mixins: [Block, Dwh],
	components: {
		BookmarkList,
		PageBlocked,
	},
	computed: {
		...mapGetters('profile', ['bookmarks', 'bookmarksMeta', 'isLoading']),
		...mapGetters('auth', ['profile']),
		...mapGetters('settings', ['appCore']),
		currentUser() {
			return this.profile
		},

		bookmarksList() {
			if (this.bookmarks.length <= 0) {
				return []
			}

			return this.bookmarks
		},
	},
	methods: {
		...mapActions('profile', ['getProfileBookmarks', 'clearBookmarks']),
		...mapActions('app', ['setPageTitle']),
		dwhViewBookmarks() {
			this.sendTrigger({
				category: 'Bookmarks',
				action: 'view_bookmarks',
				module: 'My Account',
				title: 'Bookmarks',
				id1: this.currentUser.user_id,
			})
		},
	},
	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
				search: '',
			},
			pageBlockedName: 'profile',
		}
	},
	mounted() {
		this.dwhViewBookmarks()
		this.setPageTitle('My Bookmarks')
	},
	created() {
		if (!this.isBlocked) !this.bookmarks.length && this.getProfileBookmarks()
	},
	beforeDestroy() {
		this.clearBookmarks()
	},
}
</script>

<style lang="scss">
.bookmarks-page {
	border-radius: 8px !important;
	margin-bottom: 30px;
	max-width: 555px;
	width: 100%;
	background-color: transparent !important;
	font-family: 'Inter', sans-serif;

	@media (max-width: 768px) {
		margin-bottom: 12px;
	}

	&__header {
		display: flex;
		flex-wrap: nowrap;
		justify-content: space-between;
		align-items: center;

		@media (max-width: 480px) {
			flex-direction: column;
			align-items: flex-start;
		}
	}

	&__search-wrapper {
		@media (max-width: 480px) {
			margin-top: 12px;
		}
	}

	&__title {
		font-size: 24px;
		font-weight: 700;
		line-height: 29.26px;
		color: #4a4a4a;
	}

	@media screen and (max-width: 960px) {
		.bookmarks-page__title {
			font-size: 25px !important;
		}
	}
	@media screen and (max-width: 600px) {
		.v-card__text {
			padding: 0;
		}
	}
}
</style>
